import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";

export default function MenuAccessGate({ path, action = "view", children }) {
  const [status, setStatus] = useState("loading");
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setStatus("loading");

    axios.get(`${ApiLink.API_URL}MenuAccess/check`, {
      headers: authHeader(),
      params: { path, action },
      timeout: 15000,
    }).then(({ data }) => {
      if (active) setStatus(data?.allowed === true ? "allowed" : "denied");
    }).catch((error) => {
      if (active) setStatus([401, 403].includes(error?.response?.status) ? "denied" : "error");
    });

    return () => { active = false; };
  }, [path, action, retry]);

  if (status === "allowed") return children;
  if (status === "loading") return <div role="status" style={{ padding: 32 }}>Duke kontrolluar qasjen…</div>;

  return (
    <div style={{ minHeight: "60vh", display: "grid", placeItems: "center", padding: 24 }}>
      <div style={{ maxWidth: 460, width: "100%", padding: 32, borderRadius: 16, background: "#fff", boxShadow: "0 8px 32px rgba(0, 0, 0, .08)", textAlign: "center" }}>
        <h1 style={{ fontSize: 24, marginBottom: 12 }}>
          {status === "denied" ? "Qasja nuk lejohet" : "Qasja nuk u verifikua"}
        </h1>
        <p style={{ marginBottom: 24 }}>
          {status === "denied"
            ? "Nuk keni leje për të hapur këtë faqe."
            : "Kontrolloni lidhjen me rrjetin dhe provoni përsëri."}
        </p>
        {status === "error" && <button type="button" onClick={() => setRetry(value => value + 1)}>Provo përsëri</button>}
        <Link to="/dashboard" style={{ marginLeft: status === "error" ? 16 : 0 }}>Kthehu te paneli</Link>
      </div>
    </div>
  );
}
